import './compact-post-ids';
import './user-badges-slug';
import './highest-group-badge';
import './mobile-badges-menu';
import './post-user-group-color';
import './group-colors';
import './terminal-post-group-color';
import './tag-last-post-author';
import './follow-labels';
import './numeric-tag-route';
import './user-posts-scrubber';
import './mobile-picker-position';
import './mobile-submit-near-preview';
import './suppress-network-alert';
import './login-password-toggle';
import './private-messages-access';
import './notification-enhancements';
import './fof-upload-tooltip';
import './tag-card-overflow-fade';
import './legacy-phpbb-links';
import './back-to-top';
import './desktop-tags-filter';
import './editor-tools';
import './child-forums';
import './unread-tag-links';
import './newest-sort';
import './hide-secondary-tags';
import './tag-rules';
import './markdown-help';
import './post-private-message';
import './lightbox';
import './legacy-rule-anchors';
import './tag-shortcuts';
import './single-discussion-new-topic';
import './likes-count';
import './likes-page-state';
import './link-target-preference';
import './discussion-status';
import './image-views';
import './contact-admin';
import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import TerminalPost from 'flarum/forum/components/TerminalPost';
app.initializers.add('val-ui-last-post-link', () => {
  override(TerminalPost.prototype, 'view', function (original) {
    const vnode = original();
    const discussion = this.attrs.discussion;
    const isLastPost = this.attrs.lastPost && discussion && discussion.replyCount();
    if (!isLastPost || !vnode) {
      return vnode;
    }
    const number = discussion.lastPostNumber();
    if (!number) {
      return vnode;
    }
    vnode.attrs = vnode.attrs || {};
    vnode.attrs.className = [vnode.attrs.className || '', 'ValLastPostLink'].filter(Boolean).join(' ');
    vnode.attrs.title = 'Aller au dernier message';
    vnode.attrs.onclick = event => {
      event.preventDefault();
      event.stopPropagation();
      m.route.set(app.route.discussion(discussion, number));
    };
    return vnode;
  });
});
import './linked-discussion-tags';
import './private-discussion-sidebar';
import './highest-rank-badge';
import './post-user-rank-badge';
import './restricted-access';
import './home-tree-tags';